import type {
  CustomerDrawerProfile,
  CustomerDrawerRelatedPage,
  CustomerDrawerSection,
  CustomerItem,
} from '@/services/bff/types/customer';

const EMPTY_RELATED_PAGE: CustomerDrawerRelatedPage<never> = {
  list: [],
  total: 0,
};

const buildPlaceholderSections = (
  customer: CustomerItem,
): CustomerDrawerSection[] => [
  { key: 'overview360', label: '360视图', enabled: true, count: 0 },
  { key: 'opportunities', label: '商机', enabled: true, count: 0 },
  { key: 'quotes', label: '报价单', enabled: true, count: 0 },
  { key: 'contracts', label: '合同', enabled: true, count: 0 },
  { key: 'receipts', label: '回款', enabled: true, count: 0 },
  { key: 'invoices', label: '发票', enabled: true, count: 0 },
  { key: 'contacts', label: '联系人', enabled: true, count: 0 },
  { key: 'teamMembers', label: '负责人', enabled: true, count: 0 },
  { key: 'activities', label: '活动', enabled: true, count: 0 },
  { key: 'details', label: '详细资料', enabled: true, count: 0 },
  { key: 'customerRelation', label: '客户关系', enabled: true, count: 0 },
  {
    key: 'customerAddress',
    label: '客户地址',
    enabled: true,
    count: 0,
  },
];

export const hasCustomerDrawerProfileData = (
  profile?: CustomerDrawerProfile,
): profile is CustomerDrawerProfile => Boolean(profile?.customer?.uuid);

export const normalizePlaceholderCustomerName = (value?: unknown) => {
  if (typeof value === 'string' || typeof value === 'number') {
    const text = String(value).trim();
    return text || undefined;
  }
  return undefined;
};

export const buildEmptyCustomerDrawerProfile = ({
  uuid,
  customerName,
}: {
  uuid?: string;
  customerName?: string;
}): CustomerDrawerProfile => {
  const customer: CustomerItem = {
    uuid: (uuid || '').trim(),
    name: customerName?.trim() || undefined,
    followUpStatus: 0,
    ownerTime: '',
    lockStatus: false,
    dealStatus: false,
  };

  return {
    customer,
    summary: {
      followUpCount: 0,
      unfollowedDays: null,
      contactCount: 0,
      opportunityCount: 0,
      opportunityTotalAmount: '0.00',
      wonOpportunityCount: 0,
      contractCount: 0,
      contractTotalAmount: '0.00',
      receiptTotalAmount: '0.00',
      unpaidScheduleAmount: '0.00',
      overdueScheduleAmount: '0.00',
      receiptCompletionRate: 0,
      invoiceTotalAmount: '0.00',
      invoiceCoverageRate: 0,
      healthScore: 0,
      contractExpiryRiskLevel: 'low',
      pendingCount: 0,
    },
    activities: [],
    pendingItems: [],
    sections: buildPlaceholderSections(customer),
    related: {
      contacts: EMPTY_RELATED_PAGE,
      opportunities: EMPTY_RELATED_PAGE,
      contracts: EMPTY_RELATED_PAGE,
      quotes: EMPTY_RELATED_PAGE,
      receipts: EMPTY_RELATED_PAGE,
      receiptSchedules: EMPTY_RELATED_PAGE,
      invoices: EMPTY_RELATED_PAGE,
      followUps: EMPTY_RELATED_PAGE,
      teamMembers: EMPTY_RELATED_PAGE,
      referralsIn: EMPTY_RELATED_PAGE,
      referralsOut: EMPTY_RELATED_PAGE,
      products: EMPTY_RELATED_PAGE,
      tasks: EMPTY_RELATED_PAGE,
      attachments: EMPTY_RELATED_PAGE,
      addresses: [],
    },
    ai: {
      enabled: false,
      status: 'not_configured',
    },
  };
};
